
import { Button } from 'reactstrap';
import DropzoneFileUploader from './dropzone-file-uploader';

interface FileUploaderProps {
  handleImagePicker?: () => void;
  disable?: boolean;
}

const FileUploader = ({ handleImagePicker, disable }: FileUploaderProps) => (
  <DropzoneFileUploader
    multiple
    acceptedFileTypes={['png', 'jpeg', 'jpg']}
    name="newAttachments"
    boundary={(
      <Button
        type="button"
        className="action-btn"
        color="none"
        disabled={disable}
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.1015 7.26634L8.09108 13.2768C6.72425 14.6436 4.50817 14.6436 3.14134 13.2768C1.7745 11.9099 1.7745 9.69384 3.14134 8.327L9.15174 2.3166C10.063 1.40537 11.5404 1.40537 12.4516 2.3166C13.3628 3.22782 13.3628 4.7052 12.4516 5.61643L6.67687 11.3911C6.22126 11.8467 5.48257 11.8467 5.02695 11.3911C4.57134 10.9355 4.57134 10.1968 5.02695 9.74122L10.0946 4.67362"
            stroke="#101828"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Button>
    )}
    customHandleChange={handleImagePicker}
    disabled={disable}
    enableSetErrorMessageInHookForm
    hideErrorMessage
  />
);

export default FileUploader;
